import { Drawer, Loading } from "@components";
import { useEffect, useState } from "react";
import { Titles } from "../../variables/Titles";

import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import FixedValueForm from "../types/FixedValueForm";

export const OrderSourceDataForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState([]);

  const getSourceName = (_sources, sourceAlias) => {
    const source = _sources.find((s) => s.alias == sourceAlias);
    return source ? source.name : "Desconhecido";
  };

  const loadSources = async () => {
    setLoading(true);

    //Carrega o nome das fontes
    const sources_response = await OlgaEnvironmentsAPI.getAvailableSources();
    const _sources = sources_response.getData([]);

    //Carrega as origens das fontes
    const origins_response = await OlgaEnvironmentsAPI.getExternalSourcesConfigs();
    const origin_list = origins_response.getData({});

    //Realiza a extração dos aliases unicos
    const _list = [];
    const _unique_source_aliases = new Set([]);

    const external_sources_entries = Object.entries(origin_list);
    for (const [external_source, _origins] of external_sources_entries) {
      _unique_source_aliases.add(external_source);
    }

    //Monta as opções
    for (const source_alias of [..._unique_source_aliases]) {
      _list.push({
        label: getSourceName(_sources, source_alias),
        value: source_alias,
      });
    }

    setSources(_list);
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      loadSources();
    }
  }, [visible]);

  const loading_style = {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderSourceData}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      {loading ? (
        <div style={loading_style}>
          <Loading />
        </div>
      ) : (
        <FixedValueForm
          node={node}
          options={sources}
          onSave={(node) => onSave(node)}
          onRemove={onRemove}
        />
      )}
    </Drawer>
  );
};
